module.exports = __webpack_public_path__ + "static/media/sprite.24b6beed.svg";